import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { FaRegEdit } from "react-icons/fa";
import { fetchDataFromApi, postDataToTheServer } from "../../../../../../helpers/api";
import AppURL from "../../../../../../constants/AppURL";
import Container from "../../../../../../constants/Container";
import AccountWatermarks from "../../../../../../constants/AccountWatermarks";
import { formatMoney_2 } from "../../../../../../helpers/DateFormat";
import { ToastSuccess, ToastWarning } from "../../../../../../constants/Toast";
import { VoucherContext } from "../../../../../../context/VoucherEntryContext";
import PrintSingleVoucherView from "../print/PrintSingleVoucherView";
import PrintLedgerView from "../print/PrintLedgerView";

const FullLedgerDetailsView = ({ onLedgerOpt, setOnLedgerOpt, setOnEdit }: { onLedgerOpt: any, setOnLedgerOpt: any, setOnEdit: any }) => {
    const dispatch = useDispatch();
    const [onSelect, setOnSelect] = useState(0);
    const [isLoading, setOnLoading] = useState(false);
    const [isEditLoading, setOnEditLoading] = useState(false);
    //   const { menu_list } = useSelector((state) => state?.software);
    //   const FiscalYearDate = menu_list?.current_fiscal?.from_date_n;
    const [isLeaderList, setOnLedgerList] = useState<any>([]);
    //   const { billing_list } = useSelector((state) => state?.accounts);
    const [singleLedList, setOnSingleLedList] = useState<any>([]);
    //   const billing_lists = billing_list?.print_list_bill;
    const context = useContext(VoucherContext);

    const fetachLedgerView = async () => {
        if (!context) return;
        const formData = new FormData();
        formData.append("sglsn", context.values?.sglsn || "");
        formData.append("user_id", "0");
        formData.append("fiscal_start", onLedgerOpt?.date_ne);
        formData.append("date_ne", onLedgerOpt?.date_ne);
        formData.append("member_sn", context?.values?.member_sn || '0');
        formData.append("details_mode", "1");
        if (onLedgerOpt?.open) {
            setOnLoading(true);
            try {
                await postDataToTheServer(
                    AppURL.AccountURL + "account/ledger/data/list/create/view/",
                    formData
                ).then((res) => {
                    setOnLedgerList(res);
                    setOnLoading(false);
                });
            } catch (error) {
                console.log(error);
                setOnLoading(true);
            }
        }
    };
    useEffect(() => {
        fetachLedgerView();
    }, [
        context?.values?.view_full_leader,
        context?.values?.date_ne,
        context?.values?.member_sn,
        context?.values?.sglsn,
    ]);

    const componentSingleVocuherRef = useRef<HTMLDivElement>(null);
    const printLedgerRef = useRef<HTMLDivElement>(null);
    const RenderSingleVoucherComponent = forwardRef<HTMLDivElement>((props, ref) => (
        <div ref={ref}>
            <PrintSingleVoucherView singleLedList={singleLedList} />
        </div>
    ));
    const RenderLedgerComponent = React.forwardRef(() => (
        <PrintLedgerView ledgerList={isLeaderList?.results}
            date_ne={isLeaderList?.date_ne} />
    ));
    const handlePrintSingleVoucher = useReactToPrint({
        content: () => componentSingleVocuherRef.current,
    });

    const handlePrintLedger = useReactToPrint({
        content: () => printLedgerRef.current,
    });

    const getLedgerEditView = async (tsn: number, date_ne: string) => {
        setOnEditLoading(true);
        const formData = new FormData();
        formData.append("tsn", tsn?.toString());
        try {
            await postDataToTheServer(
                AppURL.AccountURL + "account-student-ledger-get-list-view/",
                formData
            ).then((res) => {
                setOnEditLoading(false);
                if (res?.status === 208) {
                    ToastWarning({ message: res?.message });
                } else {
                    ToastSuccess({ message: res?.message });
                    setOnEdit({ edit: true, ledger: res?.results });
                }
            });
        } catch (error) {
            setOnEditLoading(false);
            console.log(error);
        }
    };

    const totalCreditAmt = isLeaderList?.results?.reduce(
        (sum: number, item: any) => sum + (item.cramt ? item.cramt : 0),
        0
    );
    const totalDebitAmt = isLeaderList?.results?.reduce((acc: number, item: any) => {
        return acc + (item?.dramt ? item?.dramt : 0);
    }, 0);

    const totalDebitCreditAmt = isLeaderList?.results?.reduce((acc: number, item: any) => {
        return acc + (item?.subaccbal ? item?.subaccbal : 0);
    }, 0);

    return (
        <Container padding>
            <div className="flex justify-between mb-2 gap-3 relative">
                <div className="flex gap-2">
                    <button
                        onClick={() => fetachLedgerView()}
                        className="py-0.5 px-3 bg-green-600 hover:bg-opacity-80 text-white text-[12px] font-public-sans rounded-sm"
                    >
                        Reload Ledger
                    </button>
                    {singleLedList?.data?.length > 0 && (
                        <button
                            onClick={handlePrintSingleVoucher}
                            className="py-0.5 px-3 bg-orange-600 hover:bg-opacity-80 text-white text-[12px] font-public-sans rounded-sm"
                            title="Single Click TSN Then Click Me"
                        >
                            Print Single Voucher
                        </button>
                    )}

                    <button
                        onClick={handlePrintLedger}
                        className="py-0.5 px-3 bg-teal-600 hover:bg-opacity-80 text-white text-[12px] font-public-sans rounded-sm"
                    >
                        Print Ledger
                    </button>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={() => setOnLedgerOpt({ open: false })}
                        className="py-0.5 px-3 bg-red-600 hover:bg-opacity-80 text-white text-[12px] font-public-sans rounded-sm"
                    >
                        Close
                    </button>
                </div>
            </div>
            <AccountWatermarks text="Ledger Details">
                <div className="relative overflow-x-auto overflow-y-auto h-[60vh]">
                    <table className="w-full text-sm text-left whitespace-nowrap rtl:text-right font-public-sans rounded-md text-slate500 dark:text-slate400">
                        <thead className="text-[11px] text-slate700 capitalize font-public-sans rounded-t-md bg-slate200 dark:bg-slate800 dark:text-slate400">
                            <tr className="top-0 z-10 sticky bg-slate-200 dark:bg-slate-800">
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700 w-16"
                                >
                                    S.N.
                                </th>
                                <th
                                    scope="col"
                                    align="left"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Date
                                </th>
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700 w-16"
                                >
                                    Receipt No
                                </th>
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700"

                                >
                                    TSN
                                </th>
                                <th
                                    scope="col"
                                    align="left"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Particular Name
                                </th>
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Debit Amount
                                </th>
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Credit Amount
                                </th>
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Sub Ac Balance
                                </th>
                                <th
                                    scope="col"
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Dr/Cr
                                </th>
                                {/* {menu_list?.ac_edit === 1 && (
                  <th
                    scope="col"
                    align="center"
                    className="px-2 py-0.5 border dark:border-slate700 w-10"
                  >
                    Reverse
                  </th>
                )} */}
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr
                                    className={`bg-white dark:bg-slate900 cursor-pointer select-none hover:bg-slate100 border-b font-public-sans font-medium  text-[12px] text-gray800 dark:text-slate300 dark:border-slate700`}
                                >
                                    <td
                                        colSpan={10}
                                        align="center"
                                        className="px-2 py-0.5 whitespace-nowrap dark:text-white border font-normal dark:border-slate700"
                                    >
                                        Loading....
                                    </td>
                                </tr>
                            ) : (
                                isLeaderList?.results?.map((ledger: any, index: number) => (
                                    <tr
                                        key={index}
                                        onClick={async () => {
                                            setOnSelect(index);
                                        }}
                                        className={`${onSelect === index
                                            ? "bg-green-100"
                                            : "bg-white hover:bg-slate100"
                                            } dark:bg-slate900 cursor-pointer select-none border-b font-public-sans font-medium  text-[12px] text-gray800 dark:text-slate300 dark:border-slate700`}
                                    >
                                        <td
                                            align="center"
                                            className="px-2 py-0.5 w-10 whitespace-nowrap dark:text-white border font-normal dark:border-slate-700"
                                        >
                                            {index + 1}.
                                        </td>
                                        <td className="px-2 py-0.5 border dark:border-slate-700 font-normal">
                                            {ledger?.dated}
                                        </td>
                                        <td
                                            align="center"
                                            className="px-2 py-0.5 border dark:border-slate-700 font-normal"

                                        >
                                            {ledger?.billrno ? ledger?.billrno : 0}
                                        </td>
                                        <td
                                            align="center"
                                            className="px-2 py-0.5 border dark:border-slate-700 font-normal"
                                            onClick={async () => {
                                                try {
                                                    await fetchDataFromApi(
                                                        AppURL.AccountURL +
                                                        "account/single/voucher/list/report/view/?tsn=" +
                                                        ledger?.tsn
                                                    ).then((res) => {
                                                        setOnSingleLedList(res);
                                                    });
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            {ledger?.tsn ? ledger?.tsn : 0}
                                        </td>
                                        <td className="px-2 py-0.5 font-normal border dark:border-slate-700">
                                            {ledger?.particulars}
                                        </td>
                                        <td
                                            align="right"
                                            className="px-2 py-0.5 font-normal border dark:border-slate-700"
                                        >
                                            {formatMoney_2(ledger?.dramt || 0)}
                                        </td>
                                        <td
                                            align="right"
                                            className="px-2 py-0.5 font-normal border dark:border-slate-700"
                                        >
                                            {formatMoney_2(ledger?.cramt || 0)}
                                        </td>
                                        <td
                                            align="right"
                                            className="px-2 py-0.5 font-normal border dark:border-slate-700"
                                        >
                                            {formatMoney_2(ledger?.subaccbal || 0)}
                                        </td>
                                        <td
                                            align="center"
                                            className="px-2 py-0.5 font-normal border dark:border-slate-700"
                                        >
                                            {ledger?.subdrcr}
                                        </td>
                                        {/* {menu_list?.ac_edit === 1 && (
                      <td
                        align="center"
                        className="px-2 py-0.5 font-normal border dark:border-slate700"
                        onClick={() =>
                          getLedgerEditView(ledger?.tsn, ledger?.dated)
                        }
                      >
                        <FaRegEdit />
                      </td>
                    )} */}
                                    </tr>
                                ))
                            )}
                            <tr
                                className={`bg-slate-100  font-public-sans font-medium text-[12px] text-gray-800`}
                            >
                                <td
                                    align="right"
                                    colSpan={5}
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    Total Amount
                                </td>

                                <td
                                    align="right"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    {formatMoney_2(totalDebitAmt || 0)}
                                </td>
                                <td
                                    align="right"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    {formatMoney_2(totalCreditAmt || 0)}
                                </td>
                                <td
                                    align="right"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                >
                                    {formatMoney_2(totalDebitCreditAmt || 0)}
                                </td>
                                <td
                                    align="center"
                                    className="px-2 py-0.5 border dark:border-slate-700"
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </AccountWatermarks>

            <div className="hidden">
                <div ref={componentSingleVocuherRef}>
                    <RenderSingleVoucherComponent />
                </div>
            </div>
            <div className="hidden">
                <div ref={printLedgerRef}>
                    <RenderLedgerComponent />
                </div>
            </div>
            {/* <Loading isSubmitting={isEditLoading} /> */}
        </Container>
    );
};

export default FullLedgerDetailsView;
